/**
 * @internal
 */
export function getBoundingClientRect(element: Element): DOMRect {
    return element.getBoundingClientRect();
}
